import { render, staticRenderFns } from "./SquareList.vue?vue&type=template&id=3cb62cf0&scoped=true"
import script from "./SquareList.vue?vue&type=script&lang=js"
export * from "./SquareList.vue?vue&type=script&lang=js"
import style0 from "./SquareList.vue?vue&type=style&index=0&id=3cb62cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb62cf0",
  null
  
)

export default component.exports